var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" Logged in "),(_vm.loggedIn)?_c('span',[_vm._v("Yes")]):_c('span',[_vm._v("No")]),_c('div',[_c('button',{on:{"click":_vm.signOut}},[_vm._v("Sign out")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }